import { useState, useEffect, useCallback } from 'react';

const NAV_ITEMS = [
  { label: 'Início', href: '#hero' },
  { label: 'Soluções', href: '#solucoes' },
  { label: 'Como Funciona', href: '#como-funciona' },
  { label: 'Sobre Mim', href: '#sobre' },
  { label: 'Contato', href: '#contato' },
];

const WHATSAPP_URL = 'https://wa.me/5535997383261?text=Ol%C3%A1%2C%20vim%20pelo%20site%20e%20gostaria%20de%20falar%20com%20o%20advogado%20criminalista%20Patrick%20Serafini';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = useCallback((e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMobileOpen(false);
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white/95 backdrop-blur-sm' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex items-center justify-between h-16 md:h-[72px]">
          {/* Logo */}
          <a href="#hero" onClick={(e) => handleNavClick(e, '#hero')} className="flex items-center gap-2 flex-shrink-0">
            <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center flex-shrink-0">
              <img
                src="https://storage.readdy-site.link/project_files/7b128e76-fd57-409d-b68f-44ee9d9ff910/87096cb3-6509-4cf5-9645-ecbc3c928ac5_logo-01.png.png?v=97043be2c98d3484e9626a0e816c7bdf"
                alt="Patrick Serafini"
                className={`w-full h-full object-contain transition-all duration-300 ${
                  scrolled ? 'brightness-0' : ''
                }`}
              />
            </div>
            <span className={`font-cinzel text-base md:text-lg font-semibold tracking-wide transition-colors ${
              scrolled ? 'text-navy' : 'text-white'
            }`}>
              Patrick Serafini
            </span>
          </a>

          {/* Desktop Links */}
          <div className="hidden md:flex items-center gap-6 lg:gap-8">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className={`font-montserrat text-sm font-light tracking-wide transition-colors hover:opacity-80 whitespace-nowrap ${
                  scrolled ? 'text-grey' : 'text-white/90'
                }`}
              >
                {item.label}
              </a>
            ))}
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 bg-green-cta text-navy font-montserrat text-sm font-medium px-4 py-2 rounded-full hover:opacity-90 transition-opacity whitespace-nowrap"
            >
              <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center" />
              WhatsApp
            </a>
          </div>

          {/* Mobile Controls */}
          <div className="flex items-center gap-3 md:hidden">
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="w-9 h-9 rounded-full bg-green-cta flex items-center justify-center"
            >
              <i className="ri-whatsapp-line w-5 h-5 flex items-center justify-center text-navy" />
            </a>
            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className={`w-9 h-9 flex items-center justify-center ${scrolled ? 'text-navy' : 'text-white'}`}
              aria-label="Menu"
            >
              <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line w-6 h-6 flex items-center justify-center`} />
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Drawer */}
      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-gray-100">
          <div className="px-4 py-4 flex flex-col gap-1">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className="font-montserrat text-sm font-light text-grey py-3 px-2 border-b border-gray-50 hover:bg-gray-50 rounded-md transition-colors"
              >
                {item.label}
              </a>
            ))}
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-3 flex items-center justify-center gap-2 bg-green-cta text-navy font-montserrat text-sm font-medium px-4 py-3 rounded-full"
            >
              <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center" />
              Falar no WhatsApp
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}